// ** Redux Imports
import { combineReducers } from "redux";

import auth from "./auth";
import navbar from "./navbar";
import layout from "./layout";
import profile from "@src/views/pages/profile/store/reducer";
import member from "@src/views/pages/member/store/reducer";
import organization from "@src/views/pages/organization/store/reducer";
import expertise from "@src/views/pages/findexpertise/store/reducer";
import checkin from "@src/views/pages/checkin/store/reducer";
import activities from "@src/views/pages/activities/store/reducer";
import monitor from "@src/views/pages/monitorcheckin/store/reducer";
import photo from "@src/views/pages/photo/store/reducer";

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  profile,
  member,
  organization,
  expertise,
  checkin,
  activities,
  monitor,
  photo,
});

export default rootReducer;
